import React from "react";

// * Components
import Book from "../../components/Book-Section/Book";
import PageInfo from "../../components/Products-Info-Section/PageInfo";

// * Datas
import { Crimes } from "../../Data/ProductData";
import { homeObjOne } from "./Data";

function Crime() {
  return (
    <>
      <PageInfo {...homeObjOne} />
      <Book items={Crimes} />
    </>
  );
}

export default Crime;
